<template>
  <div>
    <button  @click="modal = true">Send</button>
<Modal
      v-model="modal"
      width=400
      :footer-hide= true
      :closable = false
    >
      <div class="send_container">
        <h1>Send Coins</h1>
        <p>Specify the amount of additional coins for user <strong>{{row.email}}</strong></p>
        <div class="input-wrap">
          <input type="text" v-model="row.bcr_request_balance">
          <p>tpr</p>
        </div>
        <div class="check-foto_container-button">
          <button @click="send" :disabled="disable">Send</button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    props: {
      row: {
        type: Object
      }
    },
    data() {
      return {
        modal: false,
        disable: false
      }
    },
    methods: {
      send() {
        this.modal = false
        this.$store.commit('setGlobalLoading', true)
        const params = {}
        params['username'] = this.row.username
        params['amount'] = this.row.bcr_request_balance
        if (this.valid()) {
          this.disable = true
          this.$store.dispatch('sendCoin', params)
          .then(() => {
            this.$store.commit('setGlobalLoading', false)
            this.$Message.success({
              content: "Success",
              duration: 5
            })
            location.reload()
            this.disable = false

          })
          .catch(err => {
            this.$store.commit('setGlobalLoading', false)
            this.$Message.error({
              content: err.response.data.error,
              duration: 5
            })
            this.disable = false
          })
        }
      },
      valid() {
        const reg = /^(\d+\.?\d*|\.\d+)$/
        const value =  reg.test(this.row.bcr_request_balance)
       if (value) {
         return true
       } else {
         this.$Message.error({
           content: "Only numbers and one dot can be entered",
           duration: 5
         })
         return false
       }
      }
    }
  }
</script>

<style lang="scss" scoped>
button {
  background: #FADB08;
  border-radius: 4px;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 5px ;
}
.send_container {
  display: flex;
  flex-direction: column;
  h1 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
    margin-bottom: 20px;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 20px;
  }
  .input-wrap {
    position: relative;
    input {
      padding: 10px;
      margin-bottom: 20px;
      width: 100%;
      outline: none;
    }
    p {
      position: absolute;
      top: 12px;
      right: 15px;
      text-transform: uppercase;
      color: #757575;
    }
  }
  button {
    width: 100%;
    padding: 10px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-transform: uppercase;
    background: #FFE709;
    border-radius: 4px;
    border: none;
    outline: none;
    cursor: pointer;
  }
}
</style>